// Mesmos valores do enum Plano da API e do site (o valor que vale é o gravado na corretora no cadastro)
export type Plano = 'SOLO' | 'CORRETORA' | 'EQUIPE';
export type Ciclo = 'MENSAL' | 'ANUAL';

export const PLANOS: Record<Plano, { nome: string; mensal: number; mensalNoAnual: number; usuarios: number }> = {
  SOLO: { nome: 'Solo', mensal: 89, mensalNoAnual: 74, usuarios: 1 },
  CORRETORA: { nome: 'Corretora', mensal: 189, mensalNoAnual: 157, usuarios: 5 },
  EQUIPE: { nome: 'Equipe', mensal: 349, mensalNoAnual: 290, usuarios: 15 },
};

export const valorCobranca = (plano: Plano, ciclo: Ciclo) =>
  ciclo === 'ANUAL' ? PLANOS[plano].mensalNoAnual * 12 : PLANOS[plano].mensal;

export const lerPlano = (search: string): { plano: Plano; ciclo: Ciclo } => {
  const p = new URLSearchParams(search);
  const plano = (p.get('plano') || '').toUpperCase() as Plano;
  const ciclo = (p.get('ciclo') || '').toUpperCase() as Ciclo;
  return { plano: plano in PLANOS ? plano : 'CORRETORA', ciclo: ciclo === 'ANUAL' ? 'ANUAL' : 'MENSAL' };
};
